import { useTranslation } from 'react-i18next'

import Button from '../../Button'
import Text from '../../Text'
import { CalendarGridModeButton } from '../CalendarGridModeButton'

import {
  QA_NAME_CALENDAR_GRID_NEXT,
  QA_NAME_CALENDAR_GRID_PREV,
  QA_NAME_CALENDAR_GRID_RANGE,
  QA_NAME_CALENDAR_GRID_TODAY,
} from './CalendarGridNav.constants'
import {
  getCalendarGridRangeLabel,
  getIsCalendarGridModeActive,
} from './CalendarGridNav.utils'

import * as styles from './CalendarGridNav.module.css'

import ArrowLeftIcon from '../../../icons/chevrons/left.svg'
import ArrowRightIcon from '../../../icons/chevrons/right.svg'

function CalendarGridNav({
  anchor,
  days,
  isAgendaMode,
  isTodayVisible,
  locale,
  mode,
  modes,
  onChangeMode,
  onGoToNext,
  onGoToPrev,
  onGoToToday,
}) {
  const { t } = useTranslation()

  return (
    <div className={styles.CalendarGridNav}>
      <Button.Outlined
        isGrey
        beforeIconProps={{ Icon: ArrowLeftIcon }}
        disabled={isAgendaMode}
        qaName={QA_NAME_CALENDAR_GRID_PREV}
        onClick={onGoToPrev}
      />
      <Button.Outlined
        isGrey
        disabled={isTodayVisible}
        qaName={QA_NAME_CALENDAR_GRID_TODAY}
        text={t('Common.TodayDateKey')}
        onClick={onGoToToday}
      />
      <Button.Outlined
        isGrey
        beforeIconProps={{ Icon: ArrowRightIcon }}
        disabled={isAgendaMode}
        qaName={QA_NAME_CALENDAR_GRID_NEXT}
        onClick={onGoToNext}
      />
      <Text
        isSecondary
        className={styles.rangeLabel}
        qaName={QA_NAME_CALENDAR_GRID_RANGE}
      >
        {getCalendarGridRangeLabel({ anchor, days, locale, mode, t })}
      </Text>
      <div className={styles.modeToggle}>
        {modes.map(modeName => (
          <CalendarGridModeButton
            isActive={getIsCalendarGridModeActive({ mode, modeName })}
            key={modeName}
            mode={modeName}
            onChange={onChangeMode}
          />
        ))}
      </div>
    </div>
  )
}

export default CalendarGridNav
